import { jsxs as t } from "react/jsx-runtime";
import { useMultiStyleConfig as e } from "@chakra-ui/react";
import { Typography as l } from "../../dataDisplay/Typography/Typography.mjs";
const m = ({ copyright: o }) => {
  const r = e("GlobalFooter");
  return /* @__PURE__ */ t(l, { sx: r.copyright, children: [
    "© ",
    o,
    " ",
    (/* @__PURE__ */ new Date()).getFullYear()
  ] });
};
export {
  m as GlobalFooterCopyright
};
